import { pushToGTM, resetDataLayer, pushToDataLayer } from "@lib/gtmUtility"
import { getCookie } from "@commonUtils"
import { GA_EVENT_COMMON } from "@constants"
const category = "Diagnostics Lab Selection Page"

export function trackInventoryPage(city) {
    const dimensions = {
        ...window.dataLayer[0],
        visitorId: getCookie("VISITOR-ID"),
        isLoggedIn: !!getCookie("loggedIn"),
        city: city,
        page: category,
        stopPageView: true,
    }

    resetDataLayer()
    pushToDataLayer(dimensions)
    onPageViewEvent("Page View Event")
}

export function trackRemoveTest(label = "") {
    const gaConfig = {
        label,
        category,
        action: "Remove Test",
    }

    pushToGTM(gaConfig)
}

export function trackAddMoreTest(label = "") {
    const gaConfig = {
        label,
        category,
        action: "Add Test More",
    }

    pushToGTM(gaConfig)
}

export function trackSortValue(label = "") {
    const gaConfig = {
        label,
        category,
        action: "Sort Value",
    }

    pushToGTM(gaConfig)
}

export function trackAddTestHome(label, action) {
    const gaConfig = {
        label,
        category,
        action,
    }

    pushToGTM(gaConfig)
}

export function trackAddTestToCartHome(label, category, action) {
    const gaConfig = {
        label,
        category,
        action: action || "Add To Cart Home",
    }
    pushToGTM(gaConfig)
}

export function onPageViewEvent(label) {
    const gaConfig = {
        label,
        action: "Page View Action",
        eventName: GA_EVENT_COMMON.pageViewEventName,
        category,
    }
    pushToGTM(gaConfig)
}

export function trackInventoryPageInfo(label) {
    const gaConfig = {
        category,
        action: "Page info",
        label,
    }
    pushToGTM(gaConfig)
}

export function trackAddToCartWidget(label, category, action) {
    const gaConfig = {
        label: label,
        category: category,
        action: action,
    }
    pushToGTM(gaConfig)
}
